import Navigation from '@admin/components/navigation'
import Account from '@admin/components/account'
import { canAccess } from '@core/utils/access'
import Button from '@admin/components/button'
import Avatar from '@admin/components/avatar'
import Badge from '@admin/components/badge'
import Icon from '@admin/components/icon'
import T from '@admin/components/t'
import PropTypes from 'prop-types'
import React from 'react'

class Ribbon extends React.Component {

  static contextTypes = {
    admin: PropTypes.object,
    maha: PropTypes.object,
    portal: PropTypes.object,
    router: PropTypes.object
  }

  static propTypes = {}

  render() {
    const { user } = this.context.admin
    const badges = this._getBadges()
    return (
      <div className="maha-ribbon">
        <Button { ...this._getMenu() }>
          <div className="maha-badge">
            <div className="maha-badge-inner">
              <Icon svg="menu" />
            </div>
          </div>
          <span><T text="t(Apps)" /></span>
        </Button>
        <div className="maha-ribbon-spacer" />
        { badges.map((badge, index) => (
          <div className={ this._getClass(badge)} key={`badge_${index}`}>
            { badge.component ? <badge.component /> : <Badge { ...badge } /> }
            <span><T text={ badge.title } /></span>
          </div>
        ))}
        <Button { ...this._getAccount() }>
          <div className="maha-badge">
            <div className="maha-badge-inner">
              <Avatar user={ user } width={ 28 } presence={ false } />
            </div>
          </div>
          <span><T text="t(Account)" /></span>
        </Button>
      </div>
    )
  }

  _getAccess(access) {
    const { admin } = this.context
    if(access === true) return true
    return canAccess(access, admin)
  }

  _getFeatures(required) {
    const { features } = this.context.admin
    if(!required) return true
    return required.reduce((found, key) => {
      if(!found) return false
      return features[key] === true
    }, true)
  }

  _getAccount() {
    return {
      className: 'maha-ribbon-item',
      event: 'clicked \'Account\' badge in ribbon',
      handler:  this._handleDrawer.bind(this, Account),
      tooltip: {
        title: 't(Account)',
        position:'right center'
      }
    }
  }

  _getBadges() {
    const { badges } = this.context.maha
    return badges.slice().map((badge, index) => ({
      ...badge,
      index
    })).filter((badge) => {
      return this._getAccess(badge.access) && this._getFeatures(badge.features)
    }).sort((a,b) => {
      return (a.weight || 0) > (b.weight || 0) ? 1 : -1
    })
  }

  _getClass(badge) {
    const visible = badge.visible || ['desktop','tablet','mobile']
    const classes = ['maha-ribbon-item']
    if(!_.includes(visible, 'mobile')) classes.push('hide-mobile')
    if(!_.includes(visible, 'tablet')) classes.push('hide-tablet')
    if(!_.includes(visible, 'desktop')) classes.push('hide-desktop')
    return classes.join(' ')
  }

  _getMenu() {
    return {
      event: 'opened navigation',
      className: 'maha-ribbon-item',
      handler:  this._handleDrawer.bind(this, Navigation)
    }
  }

  _handleDrawer(drawer) {
    this.context.portal.setDrawer(drawer, 350)
  }

}

export default Ribbon
